"use client";
import * as React from "react";
const SvgVisibilityOffRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 2.98a3.64 3.64 0 0 1 3.64 3.63q-.01.56-.18 1.06L13.7 9.9A8.6 8.6 0 0 0 16 6.6a8.6 8.6 0 0 0-8-5.44 9 9 0 0 0-2.65.41l1.58 1.58A4 4 0 0 1 8 2.98M1.24.55a.7.7 0 0 0 0 1.02l1.44 1.44A8.7 8.7 0 0 0 0 6.6a8.6 8.6 0 0 0 11.13 4.86l1.98 1.98a.72.72 0 1 0 1.03-1.03L2.28.55a.73.73 0 0 0-1.04 0M8 10.25a3.64 3.64 0 0 1-3.64-3.64q0-.85.36-1.55L5.86 6.2q-.03.2-.04.41A2.2 2.2 0 0 0 8 8.8q.21 0 .42-.04l1.14 1.13a3.5 3.5 0 0 1-1.56.37m2.16-3.88a2.16 2.16 0 0 0-1.92-1.92z" }));
export {
  SvgVisibilityOffRound as default
};
